class FinancialUtils {
  public roundTo(value: number, digits = 2): number {
    return Math.round(value * 10 ** digits) / 10 ** digits;
  }

  public formatPrice(
    price: number | string,
    locale = 'en-US',
    currency = 'USD',
  ): string {
    if (typeof price === 'string') {
      // Remove any non-numerical characters except decimal points
      price = Number(price.replace(/[^\d.]/g, ''));
    }
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
    }).format(price);
  }

  public parsePrice(price: string): number {
    return Number(price.replace(/[^\d.]/g, ''));
  }
}

const financialUtils = new FinancialUtils();

export { financialUtils };
